import { showSuccessMessage, showWarningMessage } from '../../../_component/MessageSnack';
import axiosInstance from '../../../_config/AxiosInstance';
import config from '../../../_config/config';
import { authConstants } from '../../constant';

// login
export const sigin_user_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.SIGNIN_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.auth.signin, data);
    if (response.status) {
      dispatch({
        type: authConstants.SIGNIN_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      dispatch(get_user_action());
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: authConstants.SIGNIN_USER_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e.error || e.message);
  }
};

//signup
export const logout_user_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.LOGOUT_USER_ACTION_REQUEST,
  });
  try {
    await axiosInstance.post(config.auth.logout);
    dispatch({
      type: authConstants.LOGOUT_USER_ACTION_SUCCESS,
      payload: null,
    });
    dispatch(get_user_action());
  } catch (e) {
    dispatch({
      type: authConstants.LOGOUT_USER_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e.error || e.message);
  }
};

export const register_admin_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.REGISTER_ADMIN_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.auth.registerAdmin, data);
    if (response.status) {
      dispatch({
        type: authConstants.REGISTER_ADMIN_ACTION_SUCCESS,
        payload: response.data,
      });
      dispatch(get_user_action());
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: authConstants.REGISTER_ADMIN_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e.error || e.message);
  }
};

export const update_user_meta_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.SIGNIN_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.put(config.auth.userMeta, data);
    if (response.status) {
      dispatch({
        type: authConstants.SIGNIN_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: authConstants.SIGNIN_USER_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e.error || e.message);
  }
};

export const microsoft_redirect_callback_action = (redirect_token) => async (dispatch) => {
  dispatch({
    type: authConstants.MICROSOFT_REDIRECT_CALLBACK_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.auth.microsoftRedirectCallback, {
      redirect_token,
    });
    if (response.status) {
      dispatch({
        type: authConstants.MICROSOFT_REDIRECT_CALLBACK_ACTION_SUCCESS,
        payload: response.data,
      });
      dispatch(get_user_action());
    }
  } catch (e) {
    dispatch({
      type: authConstants.MICROSOFT_REDIRECT_CALLBACK_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e.error || e.message);
  }
};

export const forgot_password_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.FORGOT_PASSWORD_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.auth.forgotPassword, data);
    if (response.status) {
      dispatch({
        type: authConstants.FORGOT_PASSWORD_ACTION_SUCCESS,
        payload: response.data,
      });
      showSuccessMessage('Password reset email sent.');
      return true;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: authConstants.FORGOT_PASSWORD_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e.error || e.message);
    return false;
  }
};

export const reset_password_action = (id, data) => async (dispatch) => {
  dispatch({
    type: authConstants.RESET_PASSWORD_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(`${config.auth.resetPassword}/${id}`, data);
    if (response.status) {
      dispatch({
        type: authConstants.RESET_PASSWORD_ACTION_SUCCESS,
        payload: response.data,
      });
      showSuccessMessage('Password reset successfully. Login to continue.');
      return true;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: authConstants.RESET_PASSWORD_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e.error || e.message);
    return false;
  }
};

export const get_user_action = () => async (dispatch) => {
  dispatch({
    type: authConstants.GET_USER_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.auth.me);
    if (response.status) {
      dispatch({
        type: authConstants.GET_USER_SUCCESS,
        payload: response.data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: authConstants.GET_USER_FAILURE,
      payload: e?.msg,
    });
    // showWarningMessage(e.error || e.message);
    return false;
  }
};

export const microsoft_login_action = (data) => async (dispatch) => {
  dispatch({
    type: authConstants.MICROSOFT_LOGIN_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.auth.microsoftLogin, data);
    if (response.status) {
      // redirect to the microsoft login url
      window.location.href = response.data.data.url;
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: authConstants.MICROSOFT_LOGIN_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e.error || e.message);
    return false;
  }
};
